import { AppRoute } from '@app/core/routing/AppRoute';
import { Redirect, Switch } from 'react-router-dom';
import { AodPage } from '../screens/aod-root/AodPage';
import { AodRuleEditPage } from '../screens/aod-rule-edit/AodRuleEditPage';
import { AodRuleManualRunPage } from '../screens/aod-rule-manual-run/AodRuleManualRunPage';
import { AodRuleViewPage } from '../screens/aod-rule-view/AodRuleViewPage';
import { AodRuleAddPage } from '../screens/aod-rules-add/AodRuleAddPage';
import { AodRunViewPage } from '../screens/aod-run-view/AodRunViewPage';
import { aodRoutes } from './routes';

export function AodRouter() {
  return (
    <Switch>
      <AppRoute path={aodRoutes.ruleManualRun.path} component={AodRuleManualRunPage} />
      <AppRoute path={aodRoutes.ruleEdit.path} component={AodRuleEditPage} />
      <AppRoute path={aodRoutes.ruleAdd.path} component={AodRuleAddPage} />
      <AppRoute path={aodRoutes.ruleView.path} component={AodRuleViewPage} />
      <AppRoute path={aodRoutes.rules.path} component={AodPage} />
      <AppRoute path={aodRoutes.runsPast.path} component={AodPage} />
      <AppRoute path={aodRoutes.runsScheduled.path} component={AodPage} />
      <AppRoute path={aodRoutes.runView.path} component={AodRunViewPage} />
      <Redirect exact path={aodRoutes.root.path} to={aodRoutes.runsPast.path} />
    </Switch>
  );
}
